import { StoreModule } from '@ngrx/store';
import { RequestsTypeFeatureKey } from './requests-type-feature-key';
import { requestsTypeReducer } from './requests-type.reducer';

export * from './requests-type-feature-key';
export * from './requests-type.actions';
export * from './requests-type.effects';
export * from './requests-type.reducer';
export * from './requests-type.selectors';

export const RequestsTypeStoreModule = StoreModule.forFeature(
  RequestsTypeFeatureKey,
  requestsTypeReducer
);
